import { createEffect, createSignal } from "solid-js";

export const RetriedImage = (props: {
  src: string | undefined;
  retryDelayMs?: number;
  retryCount?: number;
  class?: string;
  width?: string | number;
  height?: string | number;
  alt: string;
}) => {
  const imgSrc = () => props.src || "";
  const [retryCount, setRetryCount] = createSignal(0);

  let imgRef!: HTMLImageElement;

  const loadImage = (src: string) => {
    if (!src) return;
    const img = new Image();
    img.onload = () => {
      imgRef.src = img.src;
    };
    img.onerror = () => {
      if (retryCount() < (props.retryCount || 3)) {
        setRetryCount(retryCount() + 1);
        setTimeout(() => {
          loadImage(src);
        }, props.retryDelayMs || 1000);
      }
    };
    img.src = props.src!;
  };

  createEffect(() => {
    loadImage(imgSrc());
  });

  return (
    <img
      ref={imgRef}
      alt={props.alt}
      src={imgSrc()}
      class={props.class}
      width={props.width}
      height={props.height}
    />
  );
};
